import { createContext, useContext, useState } from "react";

const PaisContext = createContext({ pais: "", setPais: () => {} });

export function PaisProvider({ children }) {
  const [pais, setPaisState] = useState(() => {
    try { return localStorage.getItem("prevelis_pais") || ""; } catch { return ""; }
  });
  const setPais = (p) => {
    try { localStorage.setItem("prevelis_pais", p); } catch (e) { console.error("No se pudo guardar el país en localStorage:", e); }
    setPaisState(p);
  };
  return <PaisContext.Provider value={{ pais, setPais }}>{children}</PaisContext.Provider>;
}

export const usePais = () => useContext(PaisContext);
